import React from "react";
import "./Profile.css";
import { BsLinkedin, BsGithub } from "react-icons/all";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";

function Profile(props) {
  return (
    <div className={"profile-container"}>
      <div className="profile-parent">
        <div className="profile-details">
          <div className={"colz"}>
            <div className="colz-icon">
              <a href={"https://www.linkedin.com/in/shankarsaiganesh/"}>
                <i>
                  <BsLinkedin />
                </i>
              </a>
              <a href={"https://github.com/ssaiganesh"}>
                <i>
                  <BsGithub />
                </i>
              </a>
            </div>
          </div>
          <div className={"profile-details-name"}>
            <span className={"primary-text"}>
              {" "}
              Hello, I'M <span className={"highlighted-text"}>Sai Ganesh</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Dev 💻",
                    1000,
                    "QA Automation Engineer 💼",
                    1000,
                    "React/React Native Dev 📱",
                    1000,
                  ]}
                />
              </h1>
              <span className="profile-role-tagline">
                Knack of building applications with front and back end
                operations.
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button
              className={"btn primary-btn"}
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Hire Me{" "}
            </button>
            <a href={"ganeshCV.pdf"} download={"Shankar Sai Ganesh Resume.pdf"}>
              <button className={"btn highlighted-btn"}>Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
